import { AxiosInstance, AxiosRequestConfig } from 'axios';

import { ProductsColumnsEnum } from '../../../../../admin-and-shop/columns/products-columns.enum';
import { axios } from '../../../../api/axios-instance';
import { productEndpoints } from '../../../../constants';
import { DeleteItemsInput } from '../../../../types';
import { PaginationRequest } from '../../../../types/pagination-request';
import { SortRequest } from '../../../../types/sort-request';
import {
  CreateProductInput,
  PaginationProductRequest,
  ProductResponse,
  ProductsResponse,
  UpdateProductInput,
} from '../../schemas/product.schema';

class ProductsApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  getProducts = async (
    data?: PaginationProductRequest & SortRequest<ProductsColumnsEnum>,
    config?: AxiosRequestConfig
  ): Promise<ProductsResponse> => {
    return await this.#requestInstance.get(productEndpoints.product, { params: data, ...config });
  };

  getArchivedProducts = async (
    data?: PaginationRequest & SortRequest<ProductsColumnsEnum>,
    config?: AxiosRequestConfig
  ): Promise<ProductsResponse> => {
    return this.#requestInstance.get(productEndpoints.getArchivedProducts, {
      params: data,
      ...config,
    });
  };

  create = async (input: CreateProductInput): Promise<ProductResponse> => {
    return this.#requestInstance.post(productEndpoints.product, { ...input, images: [] });
  };

  deleteProduct = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(productEndpoints.getProductById(id));
  };

  deleteManyProducts = async (input: DeleteItemsInput): Promise<void> => {
    return this.#requestInstance.delete(productEndpoints.product, { data: input });
  };

  getProductById = async (id: number): Promise<ProductResponse> => {
    return this.#requestInstance.get(productEndpoints.getProductById(id));
  };

  getArchivedProductById = async (id: number): Promise<ProductResponse> => {
    return this.#requestInstance.get(productEndpoints.getArchivedProductById(id));
  };

  updateProduct = async (
    input: UpdateProductInput & { isArchived?: boolean }
  ): Promise<{ message: string }> => {
    const url =
      productEndpoints.getProductById(input.id) +
      (input.isArchived !== undefined ? `?isArchived=${input.isArchived}` : '');

    return this.#requestInstance.patch(url, input.product);
  };

  archiveProduct = async (id: number, isArchived: boolean): Promise<{ message: string }> => {
    return this.#requestInstance.patch(productEndpoints.getArchivedProductById(id), { isArchived });
  };
}

export const productsApi = new ProductsApi(axios);
